// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    tab: "Tab",
    configureDescription: "Configure the description and conditional display for this tab.",
    showTabCondition: "Show this tab only when a condition is met",
    descriptionOptional: "Description (optional)",
    descriptionPlaceholder: "Enter a description shown below the tab name...",
    cancel: "Cancel",
    save: "Save",
    failedToUpdate: "Failed to update tab settings",
  },
  nb_NO: {
    settings: "Innstillinger",
    tab: "Fane",
    configureDescription: "Konfigurer beskrivelse og betinget visning for denne fanen.",
    showTabCondition: "Vis denne fanen kun når en betingelse er oppfylt",
    descriptionOptional: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Skriv inn en beskrivelse som vises under fanenavnet...",
    cancel: "Avbryt",
    save: "Lagre",
    failedToUpdate: "Kunne ikke oppdatere faneinnstillinger",
  },
} as const;
